import { Box } from "@mui/material";
import { LoginHeader } from "components/features/LoginHeader";
import { Outlet, useNavigate } from "react-router-dom";
import { useAppSelector } from "../hooks";
import { selectAuth } from "../features/authSlice";
import { CustomLoader } from "../components/ui/CustomLoader";
import { AppRoutes } from "../types/enums";
import { useEffect } from "react";

export const LoginLayout = () => {
  const navigate = useNavigate();
  const isLoggedIn = useAppSelector(selectAuth);

  useEffect(() => {
    if (isLoggedIn) {
      navigate(AppRoutes.CAMPAINGS);
    }
  }, [isLoggedIn]);

  if (isLoggedIn) {
    return <CustomLoader />;
  }
  return (
    <Box>
      <LoginHeader />
      <Outlet />
    </Box>
  );
};
